import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import CollectionPage from "./pages/CollectionPage/CollectionPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import EditProfilePage from "./pages/EditProfilePage/EditProfilePage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";
import TermsNConditionsPage from "./pages/TermsNConditionsPage/TermsNConditionsPage";
import DisclaimerPage from "./pages/DisclaimerPage/DisclaimerPage";

export default function Router({data}) {
  const routes = useRoutes([
    {
      path: "/",
      element: <HomePage data={data}/>,
    },
    {
      path: "/collection",
      element: <CollectionPage />,
    },
    {
      path: "/about-us",
      element: <AboutUsPage />,
    },
    {
      path: "/profile",
      element: <ProfilePage />,
    },
    {
      path: "/edit-profile",
      element: <EditProfilePage />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicyPage />,
    },
    {
      path: "/terms-and-conditions",
      element: <TermsNConditionsPage />,
    },
    {
      path: "/disclaimer",
      element: <DisclaimerPage />,
    },
    {
      path: "/404",
      element: <NotFoundPage />,
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
